module.exports = __webpack_public_path__ + "static/media/huawei_logo.ad0d04ac.png";